
import { createNamespacedHelpers } from 'vuex'
import { ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT } from '../../../scripts/store/actions/plp'
import { loadSectionTranslations } from '../../i18n-setup'

const { mapActions } = createNamespacedHelpers('plp')

export default {
  name: 'SghLoadMore',
  props: {
    currentPage: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 0,
    },
    totalProducts: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    totalAvailable: {
      type: Boolean,
      default: true,
    },
    searchContent: {
      type: Boolean,
      default: false,
    },
    loadMoreStyle: {
      type: Object,
      default: () => ({
        height: '2.70rem',
        width: 'fit-content',
        'font-size': '0.9rem',
        'margin-top': '1rem',
        padding: '0.75rem 3rem',
      }),
    },
  },
  computed: {
    infoLabel() {
      const b =
        this.pageSize * this.currentPage > this.totalProducts
          ? this.totalProducts
          : this.pageSize * this.currentPage
      const finalString = this.totalAvailable ? `${this.$t('plp_of')} ${this.totalProducts}` : ''
      return `${this.$t('plp_viewing')} 1 ${this.$t('plp_separator_dash')} ${b} ${finalString}`
    },
    showButton() {
      return !this.isLoading ? this.currentPage !== this.totalPages : false
    },
    buttonTitle() {
      return this.searchContent ? this.$t('plp_load_more') : this.$t('plp_load_more_sunglasses')
    },
  },
  mounted() {
    loadSectionTranslations('plp')
  },
  methods: {
    ...mapActions({
      toggle: ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT,
    }),
    click: function() {
      if (!this.searchContent) {
        this.toggle()
      }
      this.$emit('loadMore')
    },
  },
}
